module.exports = __webpack_public_path__ + "static/media/logo-empty.f8831794.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-empty.svg
// module id = 764
// module chunks = 0